import config from 'config';
import { THttpResponse } from './index.types';

export const http = <T>(request: RequestInfo): Promise<THttpResponse<T>> => {
    return new Promise((resolve, reject) => {
        let response: THttpResponse<T>;
        fetch(request, {
            ...config.fetch.common,
        })
            .then(async (res) => {
                response = res;
                let resJson: T | undefined;
                try {
                    resJson = (await res.json()) as T;
                } catch (e) {
                    console.warn('No JSON in response body');
                }
                return resJson ? resJson : undefined;
            })
            .then((parsedBody) => {
                if (response.ok) {
                    if (parsedBody) response.parsedBody = parsedBody;
                    resolve(response);
                } else {
                    reject(
                        parsedBody
                            ? parsedBody
                            : { message: response.statusText },
                    );
                }
            })
            .catch((err) => {
                reject(
                    Object.keys(err).length === 0
                        ? { message: 'Server connection error' }
                        : { message: JSON.stringify(err) },
                );
            });
    });
};

export default http;
